"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/submit text project/gwin/~/._rxjs@5.4.3@rxjs/util/isObject.js
// module id = ../../../../._rxjs@5.4.3@rxjs/util/isObject.js
// module chunks = 5